module.exports = __webpack_public_path__ + "img/Charisma-on@3x.3b99e142.png";